import styled from 'styled-components'

export const PresetsContainer = styled.div`
    width: 100%;
    padding: ${props => props.theme.paddingSM + 'px 0'};
    flex: 1;
    text-align: center;
    overflow-y: auto;
`
